import React from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import Status from "components/presentation/Status";
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SportCode from "components/common/SportCode";
import { getDateTimeFormat } from "helpers/utils";

export function Footer({ data }) {
    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode
    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            <div className="d-flex justify-content-between w-100">
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-start me-5'>{dateComponent}</div>}
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-end'><Label data='HeaderMatch' /> {numberGame}</div>}
            </div>
        </>
    )
}

export function CompetitorBlockNoData(competitor) {
    let isBlank = competitor?.cp_prev_wlt ? competitor?.cp_prev_wlt : ''
    return (
        <div className='d-flex flex-row justify-content-start'>
            <div className=''>
                {competitor && !isBlank ? competitor?.cp_prev_pos : ''}
            </div>
        </div>
    )
}
